/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Total from "./total";
import Config from "./config";
import Navbar from "../../components/Navbar";

export const WithdrawIndex = () => {
  const routes = [
    { name: "Retiros", route: "/retiros" },
    { name: "Configuración", route: "/retiros/config" },
  ];

  return <Navbar routes={routes} />;
};

export const WithdrawRoutes = [
  { path: "", Element: Total },
  { path: "config", Element: Config },
];
